export default __webpack_public_path__ + "static/media/backPopUp.702ccf14.svg";